import React from 'react'

import { CloudinaryImage } from 'ethos-design-system'
import PropTypes from 'prop-types'

import styles from './BannerImage.module.scss'

// Wow DS is so awesome that we don't even need this file! :)
// import styles from './BannerImage.module.scss'

export const BannerImage = ({ moduleData }: any) => {
  const imageProps = {
    publicId: moduleData.groupImage,
    alt: moduleData.imageAlt || 'Ethos Media',
    crop: moduleData.mediaOptions ? moduleData.mediaOptions : 'fill',
  }

  return (
    <div className={styles.root}>
      <CloudinaryImage
        {...imageProps}
        width={[327, 896, 896, 1280]}
        height={[245, 504, 504, 720]}
      />
    </div>
  )
}

BannerImage.propTypes = {
  moduleData: PropTypes.shape({
    imageAlt: PropTypes.string.isRequired,
    groupImage: PropTypes.string.isRequired,
    mediaOptions: PropTypes.string,
  }).isRequired,
}

export default BannerImage
